export const bivCodeMask = '000.000';
